function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFrame01(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 2042 2042",
    xmlns: "http://www.w3.org/2000/svg",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-732.962,-1459.34)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.5015,0,0,1.5015,-682.781,-2840.46)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1532.99,4217.71C1200.12,4173.68 942.884,3888.46 942.884,3543.63C942.884,3168.35 1247.57,2863.66 1622.85,2863.66C1998.14,2863.66 2302.82,3168.35 2302.82,3543.63C2302.82,3888.07 2046.17,4173.04 1713.83,4217.56C1755.65,4187.15 1781.55,4137.88 1782.38,4091.51C1782.6,4079.12 1780.32,4064.46 1776.01,4048.36C1992.46,3982.67 2150.2,3781.43 2150.2,3543.63C2150.2,3252.58 1913.9,3016.29 1622.85,3016.29C1331.8,3016.29 1095.51,3252.58 1095.51,3543.63C1095.51,3781.26 1253.02,3982.39 1469.24,4048.22C1464.95,4064.54 1462.86,4079.35 1463.41,4091.83C1463.75,4138.31 1490.57,4187.44 1532.99,4217.71Z",
    style: {
      fill: "rgb(18,184,227)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.13839,0,0,1.13839,775.559,648.867)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M849.382,1988.49C849.839,1987.84 850.357,1987.23 850.933,1986.65C851.914,1985.67 853.018,1984.86 854.201,1984.23C856.274,1983.12 858.539,1982.59 860.787,1982.59C863.035,1982.59 865.299,1983.13 867.369,1984.25C868.551,1984.88 869.653,1985.69 870.632,1986.68C871.207,1987.25 871.723,1987.87 872.179,1988.52C908.754,2038.62 961.544,2119.89 997.639,2194.97C1022.61,2246.91 1039.36,2296.16 1038.74,2330.88C1037.25,2414 963.99,2505.43 860.802,2505.66C757.742,2505.89 680.481,2414.72 680.251,2331.01C678.527,2297.48 694.284,2249.86 719.053,2198.85C754.786,2125.26 808.732,2043.89 849.382,1988.49ZM860.717,2020.32C822.579,2073.61 775.945,2145.45 744.11,2211.02C721.752,2257.06 706.404,2299.69 708.083,2329.85C708.098,2330.11 708.105,2330.37 708.105,2330.63C708.105,2401.31 773.71,2478 860.74,2477.81C947.796,2477.61 1009.63,2400.51 1010.89,2330.38C1011.46,2298.8 995.254,2254.29 972.535,2207.04C940.686,2140.79 895.536,2069.63 860.717,2020.32Z",
    style: {
      fill: "rgb(18,184,227)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.759863,0,0,0.759863,-1776.43,2474.95)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.49815,0,0,1.49815,3358.48,-2403.17)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M849.382,1988.49C849.839,1987.84 850.357,1987.23 850.933,1986.65C851.914,1985.67 853.018,1984.86 854.201,1984.23C856.274,1983.12 858.539,1982.59 860.787,1982.59C863.035,1982.59 865.299,1983.13 867.369,1984.25C868.551,1984.88 869.653,1985.69 870.632,1986.68C871.207,1987.25 871.723,1987.87 872.179,1988.52C908.754,2038.62 961.544,2119.89 997.639,2194.97C1022.61,2246.91 1039.36,2296.16 1038.74,2330.88C1037.25,2414 963.99,2505.43 860.802,2505.66C757.742,2505.89 680.481,2414.72 680.251,2331.01C678.527,2297.48 694.284,2249.86 719.053,2198.85C754.786,2125.26 808.732,2043.89 849.382,1988.49ZM860.717,2020.32C822.579,2073.61 775.945,2145.45 744.11,2211.02C721.752,2257.06 706.404,2299.69 708.083,2329.85C708.098,2330.11 708.105,2330.37 708.105,2330.63C708.105,2401.31 773.71,2478 860.74,2477.81C947.796,2477.61 1009.63,2400.51 1010.89,2330.38C1011.46,2298.8 995.254,2254.29 972.535,2207.04C940.686,2140.79 895.536,2069.63 860.717,2020.32Z",
    style: {
      fill: "rgb(18,184,227)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.49815,0,0,1.49815,3286.19,-2414.4)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M781.817,2385.19C778.651,2378.19 781.768,2369.93 788.773,2366.76C795.778,2363.6 804.034,2366.72 807.2,2373.72C819.236,2400.36 842.479,2423.24 864.586,2433.71C871.532,2437 874.5,2445.31 871.209,2452.26C867.918,2459.21 859.606,2462.17 852.66,2458.88C825.439,2445.99 796.638,2417.99 781.817,2385.19Z",
    style: {
      fill: "rgb(18,184,227)"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,296.238,-1394.86)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(43.7007,-160.835,160.835,43.7007,627.651,3699.92)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.049,-0.726L0.533,-0.726L0.533,-0.623L0.342,-0.623L0.342,-0L0.235,-0L0.235,-0.623L0.049,-0.623L0.049,-0.726Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(64.023,-153.879,153.879,64.023,653.157,3604.24)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.102,-0.726L0.579,-0.726L0.579,-0.623L0.209,-0.623L0.209,-0.416L0.538,-0.416L0.538,-0.313L0.209,-0.313L0.209,-0.103L0.593,-0.103L0.593,-0L0.102,-0L0.102,-0.726Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(83.601,-144.183,144.183,83.601,695.451,3501.77)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.637,-0.055C0.626,-0.048 0.611,-0.039 0.59,-0.029C0.569,-0.018 0.544,-0.009 0.516,-0.002C0.487,0.005 0.456,0.009 0.422,0.008C0.365,0.007 0.315,-0.003 0.27,-0.022C0.225,-0.041 0.186,-0.068 0.155,-0.102C0.124,-0.135 0.099,-0.174 0.083,-0.218C0.066,-0.261 0.057,-0.308 0.057,-0.357C0.057,-0.412 0.066,-0.462 0.083,-0.508C0.1,-0.553 0.125,-0.593 0.158,-0.627C0.19,-0.661 0.228,-0.687 0.272,-0.706C0.315,-0.725 0.363,-0.734 0.415,-0.734C0.46,-0.734 0.5,-0.728 0.536,-0.716C0.572,-0.704 0.602,-0.69 0.627,-0.674L0.585,-0.574C0.566,-0.587 0.542,-0.6 0.514,-0.613C0.485,-0.625 0.454,-0.631 0.419,-0.631C0.385,-0.631 0.353,-0.624 0.323,-0.611C0.292,-0.597 0.266,-0.578 0.243,-0.554C0.22,-0.529 0.201,-0.501 0.188,-0.469C0.175,-0.436 0.168,-0.401 0.168,-0.363C0.168,-0.324 0.174,-0.289 0.186,-0.256C0.198,-0.223 0.215,-0.195 0.238,-0.171C0.26,-0.147 0.287,-0.128 0.318,-0.115C0.349,-0.102 0.385,-0.095 0.424,-0.095C0.461,-0.095 0.494,-0.101 0.523,-0.112C0.551,-0.123 0.574,-0.136 0.592,-0.151L0.637,-0.055Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(103.874,-130.338,130.338,103.874,754.13,3399.75)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.684,-0.726L0.684,-0L0.577,-0L0.577,-0.313L0.209,-0.313L0.209,-0L0.102,-0L0.102,-0.726L0.209,-0.726L0.209,-0.415L0.577,-0.415L0.577,-0.726L0.684,-0.726Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(123.456,-111.966,111.966,123.456,837.011,3295.46)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.735,0.025L0.176,-0.53L0.207,-0.52L0.21,-0L0.102,-0L0.102,-0.749L0.107,-0.749L0.659,-0.193L0.634,-0.2L0.632,-0.726L0.738,-0.726L0.738,0.025L0.735,0.025Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(140.46,-89.7144,89.7144,140.46,942.239,3200.09)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.057,-0.362C0.057,-0.412 0.067,-0.459 0.086,-0.504C0.105,-0.549 0.131,-0.588 0.165,-0.623C0.199,-0.658 0.238,-0.685 0.283,-0.705C0.328,-0.724 0.376,-0.734 0.427,-0.734C0.478,-0.734 0.525,-0.724 0.57,-0.705C0.615,-0.685 0.654,-0.658 0.689,-0.623C0.724,-0.588 0.751,-0.549 0.77,-0.504C0.789,-0.459 0.799,-0.412 0.799,-0.362C0.799,-0.311 0.789,-0.263 0.77,-0.218C0.751,-0.173 0.724,-0.134 0.69,-0.1C0.655,-0.066 0.616,-0.04 0.571,-0.021C0.526,-0.002 0.478,0.008 0.427,0.008C0.376,0.008 0.328,-0.001 0.283,-0.02C0.238,-0.039 0.199,-0.065 0.165,-0.099C0.131,-0.132 0.105,-0.171 0.086,-0.217C0.067,-0.262 0.057,-0.31 0.057,-0.362ZM0.167,-0.362C0.167,-0.325 0.174,-0.29 0.188,-0.258C0.201,-0.225 0.22,-0.197 0.244,-0.173C0.268,-0.148 0.296,-0.129 0.328,-0.116C0.359,-0.102 0.393,-0.095 0.43,-0.095C0.466,-0.095 0.5,-0.102 0.531,-0.116C0.562,-0.129 0.59,-0.148 0.614,-0.173C0.637,-0.197 0.656,-0.225 0.669,-0.258C0.682,-0.29 0.689,-0.325 0.689,-0.362C0.689,-0.399 0.682,-0.434 0.669,-0.467C0.655,-0.499 0.636,-0.527 0.613,-0.552C0.589,-0.577 0.561,-0.596 0.53,-0.61C0.498,-0.624 0.464,-0.631 0.428,-0.631C0.391,-0.631 0.356,-0.624 0.325,-0.61C0.294,-0.596 0.266,-0.577 0.242,-0.552C0.218,-0.527 0.2,-0.499 0.187,-0.466C0.173,-0.433 0.167,-0.399 0.167,-0.362Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(152.498,-67.2472,67.2472,152.498,1064.78,3123.36)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.102,-0.726L0.209,-0.726L0.209,-0.103L0.572,-0.103L0.572,-0L0.102,-0L0.102,-0.726Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(160.456,-45.0752,45.0752,160.456,1159.2,3079.9)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.057,-0.362C0.057,-0.412 0.067,-0.459 0.086,-0.504C0.105,-0.549 0.131,-0.588 0.165,-0.623C0.199,-0.658 0.238,-0.685 0.283,-0.705C0.328,-0.724 0.376,-0.734 0.427,-0.734C0.478,-0.734 0.525,-0.724 0.57,-0.705C0.615,-0.685 0.654,-0.658 0.689,-0.623C0.724,-0.588 0.751,-0.549 0.77,-0.504C0.789,-0.459 0.799,-0.412 0.799,-0.362C0.799,-0.311 0.789,-0.263 0.77,-0.218C0.751,-0.173 0.724,-0.134 0.69,-0.1C0.655,-0.066 0.616,-0.04 0.571,-0.021C0.526,-0.002 0.478,0.008 0.427,0.008C0.376,0.008 0.328,-0.001 0.283,-0.02C0.238,-0.039 0.199,-0.065 0.165,-0.099C0.131,-0.132 0.105,-0.171 0.086,-0.217C0.067,-0.262 0.057,-0.31 0.057,-0.362ZM0.167,-0.362C0.167,-0.325 0.174,-0.29 0.188,-0.258C0.201,-0.225 0.22,-0.197 0.244,-0.173C0.268,-0.148 0.296,-0.129 0.328,-0.116C0.359,-0.102 0.393,-0.095 0.43,-0.095C0.466,-0.095 0.5,-0.102 0.531,-0.116C0.562,-0.129 0.59,-0.148 0.614,-0.173C0.637,-0.197 0.656,-0.225 0.669,-0.258C0.682,-0.29 0.689,-0.325 0.689,-0.362C0.689,-0.399 0.682,-0.434 0.669,-0.467C0.655,-0.499 0.636,-0.527 0.613,-0.552C0.589,-0.577 0.561,-0.596 0.53,-0.61C0.498,-0.624 0.464,-0.631 0.428,-0.631C0.391,-0.631 0.356,-0.624 0.325,-0.61C0.294,-0.596 0.266,-0.577 0.242,-0.552C0.218,-0.527 0.2,-0.499 0.187,-0.466C0.173,-0.433 0.167,-0.399 0.167,-0.362Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(165.57,-19.0848,19.0848,165.57,1298.5,3041.78)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.675,-0.064C0.665,-0.055 0.651,-0.047 0.633,-0.038C0.615,-0.029 0.595,-0.022 0.573,-0.015C0.55,-0.008 0.527,-0.003 0.504,0.002C0.481,0.006 0.459,0.008 0.438,0.008C0.379,0.008 0.327,-0.001 0.28,-0.019C0.233,-0.037 0.193,-0.062 0.16,-0.094C0.127,-0.126 0.101,-0.164 0.084,-0.207C0.066,-0.25 0.057,-0.296 0.057,-0.347C0.057,-0.409 0.067,-0.464 0.087,-0.512C0.107,-0.56 0.134,-0.6 0.169,-0.634C0.203,-0.667 0.243,-0.692 0.288,-0.709C0.333,-0.725 0.38,-0.734 0.429,-0.734C0.472,-0.734 0.513,-0.729 0.55,-0.719C0.587,-0.709 0.618,-0.696 0.645,-0.68L0.61,-0.582C0.597,-0.589 0.58,-0.596 0.561,-0.604C0.541,-0.611 0.521,-0.616 0.5,-0.62C0.479,-0.624 0.46,-0.626 0.443,-0.626C0.4,-0.626 0.362,-0.62 0.329,-0.608C0.295,-0.595 0.266,-0.577 0.242,-0.554C0.218,-0.531 0.2,-0.502 0.187,-0.469C0.173,-0.436 0.167,-0.398 0.167,-0.356C0.167,-0.318 0.174,-0.283 0.187,-0.252C0.2,-0.22 0.219,-0.193 0.243,-0.17C0.267,-0.147 0.296,-0.129 0.329,-0.117C0.362,-0.104 0.399,-0.098 0.44,-0.098C0.463,-0.098 0.486,-0.1 0.509,-0.105C0.532,-0.11 0.551,-0.116 0.567,-0.125L0.567,-0.257L0.427,-0.257L0.427,-0.36L0.675,-0.36L0.675,-0.064Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(166.663,-1.05708,1.05708,166.663,1425.46,3029.38)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.102,
    y: -0.726,
    width: 0.107,
    height: 0.726,
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(165.94,15.5503,-15.5503,165.94,1478.96,3027.52)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.102,-0.726L0.579,-0.726L0.579,-0.623L0.209,-0.623L0.209,-0.416L0.538,-0.416L0.538,-0.313L0.209,-0.313L0.209,-0.103L0.593,-0.103L0.593,-0L0.102,-0L0.102,-0.726Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(159.191,49.3554,-49.3554,159.191,1643.53,3047.18)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.102,-0L0.102,-0.726L0.304,-0.726C0.376,-0.726 0.437,-0.715 0.488,-0.693C0.539,-0.671 0.58,-0.642 0.611,-0.606C0.642,-0.57 0.664,-0.53 0.679,-0.486C0.693,-0.442 0.7,-0.398 0.7,-0.353C0.7,-0.299 0.69,-0.25 0.671,-0.207C0.652,-0.164 0.625,-0.127 0.592,-0.096C0.559,-0.065 0.52,-0.041 0.477,-0.025C0.434,-0.008 0.388,-0 0.339,-0L0.102,-0ZM0.209,-0.103L0.319,-0.103C0.358,-0.103 0.395,-0.109 0.428,-0.12C0.46,-0.131 0.489,-0.148 0.514,-0.17C0.538,-0.192 0.557,-0.219 0.57,-0.251C0.583,-0.283 0.59,-0.32 0.59,-0.361C0.59,-0.406 0.583,-0.444 0.568,-0.478C0.553,-0.511 0.533,-0.538 0.508,-0.56C0.483,-0.581 0.456,-0.597 0.426,-0.608C0.395,-0.618 0.364,-0.623 0.333,-0.623L0.209,-0.623L0.209,-0.103Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(153.234,65.5518,-65.5518,153.234,1765.14,3086.79)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.102,
    y: -0.726,
    width: 0.107,
    height: 0.726,
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(145.767,80.8069,-80.8069,145.767,1815.1,3106.47)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.028,-0L0.347,-0.755L0.353,-0.755L0.672,-0L0.55,-0L0.318,-0.588L0.395,-0.639L0.133,-0L0.028,-0ZM0.222,-0.272L0.48,-0.272L0.517,-0.18L0.19,-0.18L0.222,-0.272Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(133.421,99.8835,-99.8835,133.421,1918.5,3164.14)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.295,-0.726C0.368,-0.726 0.426,-0.711 0.469,-0.681C0.511,-0.651 0.532,-0.605 0.532,-0.543C0.532,-0.503 0.523,-0.469 0.505,-0.44C0.486,-0.411 0.461,-0.389 0.429,-0.374C0.396,-0.358 0.358,-0.349 0.314,-0.347L0.298,-0.404C0.349,-0.403 0.395,-0.394 0.436,-0.378C0.476,-0.361 0.508,-0.338 0.532,-0.31C0.555,-0.281 0.567,-0.246 0.567,-0.206C0.567,-0.169 0.56,-0.138 0.547,-0.112C0.533,-0.085 0.515,-0.064 0.492,-0.048C0.468,-0.031 0.443,-0.019 0.414,-0.012C0.385,-0.004 0.354,-0 0.323,-0L0.102,-0L0.102,-0.726L0.295,-0.726ZM0.314,-0.412C0.351,-0.412 0.379,-0.423 0.396,-0.444C0.413,-0.465 0.422,-0.491 0.422,-0.52C0.422,-0.556 0.411,-0.582 0.389,-0.599C0.366,-0.615 0.337,-0.623 0.3,-0.623L0.209,-0.623L0.209,-0.412L0.314,-0.412ZM0.318,-0.099C0.344,-0.099 0.368,-0.103 0.389,-0.111C0.409,-0.118 0.426,-0.13 0.439,-0.146C0.451,-0.161 0.457,-0.181 0.457,-0.205C0.457,-0.232 0.45,-0.253 0.436,-0.268C0.421,-0.282 0.403,-0.293 0.381,-0.3C0.358,-0.306 0.335,-0.309 0.311,-0.309L0.209,-0.309L0.209,-0.099L0.318,-0.099Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(119.722,115.95,-115.95,119.722,2003.6,3227.24)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.102,-0.726L0.579,-0.726L0.579,-0.623L0.209,-0.623L0.209,-0.416L0.538,-0.416L0.538,-0.313L0.209,-0.313L0.209,-0.103L0.593,-0.103L0.593,-0L0.102,-0L0.102,-0.726Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(105.134,129.324,-129.324,105.134,2082.97,3304.47)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.049,-0.726L0.533,-0.726L0.533,-0.623L0.342,-0.623L0.342,-0L0.235,-0L0.235,-0.623L0.049,-0.623L0.049,-0.726Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(87.8038,141.663,-141.663,87.8038,2145.84,3381.03)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.294,-0.239L0.025,-0.726L0.157,-0.726L0.366,-0.33L0.334,-0.328L0.541,-0.726L0.672,-0.726L0.401,-0.239L0.401,-0L0.294,-0L0.294,-0.239Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(66.2546,152.932,-152.932,66.2546,2208.33,3481.39)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.21,-0.44L0.207,-0.404L0.222,-0.425L0.506,-0.726L0.644,-0.726L0.344,-0.411L0.658,-0L0.523,-0L0.266,-0.344L0.21,-0.289L0.21,-0L0.102,-0L0.102,-0.726L0.21,-0.726L0.21,-0.44Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(45.5738,160.315,-160.315,45.5738,2254.76,3587.58)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.028,-0L0.347,-0.755L0.353,-0.755L0.672,-0L0.55,-0L0.318,-0.588L0.395,-0.639L0.133,-0L0.028,-0ZM0.222,-0.272L0.48,-0.272L0.517,-0.18L0.19,-0.18L0.222,-0.272Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFrame01);
export default __webpack_public_path__ + "static/media/frame01.905f0be6b7bbb30cdc4d8d2439b467b2.svg";
export { ForwardRef as ReactComponent };